import React from 'react';
import { Link } from 'react-router-dom';
import { Anchor, Stack, Text, Tooltip } from '@mantine/core';
import { APP_ROUTES } from '../../navigation/appRoutes';
import { APP_BRAND } from '../../theme/brand';
import { getCustomerDisplayName } from '../../utils/customerDisplay';

export interface AppBrandBlockProps {
  collapsed?: boolean;
  onNavigate?: () => void;
}

function BrandMark() {
  return (
    <span className="app-brand-block__mark" aria-hidden>
      F
    </span>
  );
}

export function AppBrandBlock({ collapsed = false, onNavigate }: AppBrandBlockProps) {
  const productTitle = APP_BRAND.productName;
  const customerDisplay = getCustomerDisplayName();

  const brandTooltip = (
    <Stack gap={2}>
      <Text size="sm">{productTitle}</Text>
      {customerDisplay ? (
        <Text size="xs" c="dimmed">
          {customerDisplay}
        </Text>
      ) : null}
    </Stack>
  );

  if (collapsed) {
    return (
      <Tooltip label={brandTooltip}>
        <Anchor
          component={Link}
          to={APP_ROUTES.dashboard.overview}
          underline="never"
          className="app-brand-block app-brand-block--collapsed"
          onClick={onNavigate}
          aria-label={productTitle}
        >
          <BrandMark />
        </Anchor>
      </Tooltip>
    );
  }

  return (
    <Anchor
      component={Link}
      to={APP_ROUTES.dashboard.overview}
      underline="never"
      className="app-brand-block"
      onClick={onNavigate}
    >
      <BrandMark />
      <span className="app-brand-block__text">
        <span className="app-brand-block__title">{productTitle}</span>
        {customerDisplay ? (
          <span className="app-brand-block__subtitle" title={customerDisplay}>
            {customerDisplay}
          </span>
        ) : null}
      </span>
    </Anchor>
  );
}
